import React, { useEffect, useMemo, useState } from "react";
import { ArticlesFeatured } from "agronomist-ui-components";
import { useTranslation } from "react-i18next";
import { serializeArticleDataToCard } from "../../../services/helpers/articles";
import { useFeaturedArticles } from "./ArticlesSection.hooks";
import { useLinks } from "../../../services/helpers/links";
import { getMediaUrlMeta } from "../../../services/helpers/video-cover";

const ArticlesFeaturedSection = () => {
  const [thumbnails, setThumbnails] = useState({});
  const { t } = useTranslation(["articlesMeta"]);
  const { articles } = useFeaturedArticles();
  const { article: articleLink } = useLinks();
  const list = useMemo(() => {
    return articles.slice(0, 4).map(el => {
      const serializedArticle = serializeArticleDataToCard(el, t, articleLink);
      if (thumbnails[el.id]) {
        serializedArticle.coverUrl = thumbnails[el.id];
      }
      return serializedArticle;
    });
  });

  const getThumbs = async () => {
    const thumbs = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const article of articles) {
      if (article.thumb && (article.thumb.file || article.thumb.file_webp)) {
        thumbs[article.id] = article.thumb.file_webp || article.thumb.file;
      } else if (article.video_url) {
        // eslint-disable-next-line no-await-in-loop
        await getMediaUrlMeta(article.video_url, thumb => {
          thumbs[article.id] = thumb;
        });
      }
    }
    setThumbnails(thumbs);
  };

  useEffect(() => {
    if (articles.length) {
      getThumbs();
    }
  }, [articles.length]);

  return <ArticlesFeatured articles={list} />;
};

export default ArticlesFeaturedSection;
